var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "WarehouseClients"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 s1 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('warehouseClientList.warehouseClientListing')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 s0 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 s1 o3  cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', {
    staticClass: "theader"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_vm._m(0), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('warehouseClientList.clientName')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('warehouseClientList.action')))])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listClientData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center ",
      attrs: {
        "scope": "row"
      }
    }, [_c('strong', [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWarehouseClientRowData(data)
        }
      }
    })])])
  }))])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listClientData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.addwarehouseclientmodal = false
      }
    },
    model: {
      value: (_vm.addwarehouseclientmodal),
      callback: function($$v) {
        _vm.addwarehouseclientmodal = $$v
      },
      expression: "addwarehouseclientmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [(_vm.warehouseclientaction == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Add Warehouse Client")]) : _vm._e(), _vm._v(" "), (_vm.warehouseclientaction == 'edit') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v(_vm._s(_vm.$t('warehouseClientList.editWarehouseClient')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeAddWarehouseClientModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('label', [_vm._v(_vm._s(_vm.$t('warehouseClientList.selectWareHouse')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', {
    staticClass: "pref-button"
  }), _vm._v(" "), _c('div', _vm._l((_vm.listWarehouseData), function(select) {
    return _c('label', {
      key: select.warehouseid,
      staticStyle: {
        "padding-left": "10pt",
        "padding-right": "10pt",
        "width": "20%"
      },
      attrs: {
        "for": select.warehousename
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedWarehouse),
        expression: "checkedWarehouse"
      }],
      class: select.class,
      attrs: {
        "id": select.warehousename,
        "sector": select.warehouseid,
        "type": "checkbox"
      },
      domProps: {
        "value": select.warehouseid,
        "checked": Array.isArray(_vm.checkedWarehouse) ? _vm._i(_vm.checkedWarehouse, select.warehouseid) > -1 : (_vm.checkedWarehouse)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkedWarehouse,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = select.warehouseid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedWarehouse = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.checkedWarehouse = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedWarehouse = $$c
          }
        }
      }
    }), _vm._v(" " + _vm._s(select.warehousename))])
  }))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "warehousefooter form-actions"
  }, [(_vm.warehouseclientaction == 'add') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveWarehouseclient
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('common.saveBtn')))]) : _vm._e(), _vm._v(" \n            "), _vm._v(" "), (_vm.warehouseclientaction == 'edit') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.editWarehouseClient
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.update')))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeAddWarehouseClientModal
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.$t('printProductDetails.cancel')))])])])], 1)])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" # ")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62b39325", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62b39325","hasScoped":true}!./src/views/components/warehouseclient/warehouseclient.component.html
// module id = 1572
// module chunks = 0